"use strict";
/**
 * @author: yangqianjun
 * @file: 类似 dva model 的 TypeScript 封装
 * @Date: 2019-11-19 16:14:12
 * @LastEditors: yangqianjun
 * @LastEditTime: 2020-01-06 18:24:59
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var immer_1 = require("immer");
var sagaEffects = tslib_1.__importStar(require("redux-saga/effects"));
var actions_1 = require("@tkit/actions");
var event_1 = require("@tkit/event");
// IMP: 解除循环依赖
var consts_1 = require("@tkit/async/lib/consts");
tslib_1.__exportStar(require("redux-saga/effects"), exports);
exports.sagaAll = sagaEffects.all, exports.sagaCall = sagaEffects.call, exports.cancelled = sagaEffects.cancelled;
exports.effects = sagaEffects;
/**
 * Redux Type 副作用开始
 */
exports.EFFECTS_START = 'EFFECTS_START';
/**
 * Redux Type 副作用结束
 */
exports.EFFECTS_END = 'EFFECTS_END';
/**
 * Redux Type 副作用错误
 */
exports.EFFECTS_ERROR = 'EFFECTS_ERROR';
/**
 * Redux Type 副作用成功
 */
exports.EFFECTS_SUCCESS = 'EFFECTS_SUCCESS';
/**
 * 副作用消息EventCenter事件
 */
exports.EFFECTS_MSG = 'EFFECTS_MSG';
/**
 * redux和useReducer dispatch wrapper
 * @param put Dispatch
 */
function putWrapper(put) {
    if (put === void 0) { put = globalPut; }
    return function (effect) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof effect === 'function') {
            put(effect.apply(void 0, args));
        }
        else if (typeof effect === 'string') {
            put({ type: effect, payload: args[1] });
        }
        else if (typeof effect === 'object') {
            put(effect);
        }
    };
}
exports.putWrapper = putWrapper;
var wrappedPut = putWrapper();
function tPut(effect) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return wrappedPut.apply(void 0, tslib_1.__spreadArrays([effect], args));
}
exports.tPut = tPut;
function globalPut(action) {
    // @fix: 解除循环依赖 for commonjs
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('@src/store').default.dispatch(action);
}
exports.globalPut = globalPut;
function tCall(effect) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    // 不可以: sagaCall(effect, ...args)
    return exports.sagaCall.apply(null, tslib_1.__spreadArrays([effect], args));
}
exports.tCall = tCall;
var defaultEffectOptions = {
    type: 'takeEvery',
    ms: 100
};
/**
 * Model工厂
 * @param model
 * @param model.namespace 命令空间
 * @param model.state 初始状态
 * @param model.reducers 推导reducers和同步actions
 * @param model.effects 副作用，推导异步actions
 */
function createModel(model) {
    var namespace = model.namespace, state = model.state, reducers = model.reducers, effects = model.effects, modern = model.m;
    var reducersMap = {};
    var TYPES = {};
    var actions = Object.keys(reducers).reduce(function (actions, doSomething) {
        var type = (TYPES[doSomething] = namespace + "/" + doSomething);
        // 引入 immer & 自动 namespace 隔离
        reducersMap[type] =
            modern === 0 /* ReduxModern */
                ? function (state, action) {
                    var _a;
                    return tslib_1.__assign(tslib_1.__assign({}, state), (_a = {}, _a[namespace] = immer_1.produce(state[namespace], function (draftState) {
                        return reducers[doSomething](draftState, action);
                    }), _a));
                }
                : modern === 1 /* HookModern */
                    ? function (state, action) {
                        // cheat
                        return immer_1.produce(state, function (draftState) { return reducers[doSomething](draftState, action); });
                    }
                    : reducers[doSomething];
        actions[doSomething] = (function (payload) {
            return actions_1.createAction(type, payload);
        });
        return actions;
    }, 
    // eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion
    {});
    var genSagas = [];
    var CustomEffects = tslib_1.__assign(tslib_1.__assign({}, sagaEffects), { namespace: namespace, tPut: tPut, tCall: tCall });
    if (effects) {
        actions = Object.keys(effects).reduce(function (actions, doSomethingAsync) {
            var type = (TYPES[doSomethingAsync] = namespace + "/" + doSomethingAsync);
            if (doSomethingAsync in actions) {
                console.error("[Critical Error]: action '" + doSomethingAsync + "' already exists!!");
            }
            else {
                actions[doSomethingAsync] = (function (payload) {
                    return actions_1.createAction(type, payload);
                });
                var saga = effects[doSomethingAsync];
                var effectOptions = defaultEffectOptions;
                if (Array.isArray(saga)) {
                    effectOptions = tslib_1.__assign(tslib_1.__assign({}, defaultEffectOptions), saga[1]);
                    saga = saga[0];
                }
                var effect = effectWrapper(saga, CustomEffects, type, effectOptions);
                switch (effectOptions.type) {
                    case 'throttle':
                        genSagas.push(sagaEffects.throttle(effectOptions.ms || 100, type, effect));
                        break;
                    case 'takeEvery':
                    case 'takeLatest':
                        genSagas.push(sagaEffects[effectOptions.type](type, effect));
                        break;
                }
            }
            return actions;
        }, actions);
    }
    return {
        state: state,
        actions: actions,
        reducers: actions_1.handleActions(reducersMap, state),
        sagas: function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, exports.sagaAll(genSagas)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        },
        TYPES: TYPES,
        effects: tslib_1.__assign({}, effects),
        namespace: namespace,
        __model: model
    };
}
exports.default = createModel;
var fakeEffectRes = { code: 0 };
function effectWrapper(effect, effects, effectName, EffectOptions) {
    var _this = this;
    var put = effects.tPut;
    /**
     * 默认不展示loading
     */
    var loading = (EffectOptions && EffectOptions.loading) || false;
    var local = (EffectOptions && EffectOptions.local) || false;
    var silent = EffectOptions && EffectOptions.silent;
    /** 支持并发 */
    var effectFactory = function () {
        var rs = function () { return 0; };
        var res = {
            code: 0,
            message: false
        };
        var getMsg = function () { return typeof res.message !== 'object' && res.message; };
        var interactEffect = rs;
        // 自动模拟 loading & 成功错误信息效果
        if (silent !== true) {
            interactEffect = function () {
                res.code = 0;
                res.message = false;
                // IMP: 有些Effects可能是同步的，所以对rs的赋值必须是同步，而不是在fetch被调用的时候
                var prom = new Promise(function (resolve) {
                    // IMP: fakeEffect must be successful // 我有点记不得这是为啥了
                    // loading 交互效果由 prom mock 出来，在真正的 fetch effect 执行完成后 resolve
                    // FIX: 如果恒返回 fakeEffectRes，那么错误信息就显示吧出来
                    rs = function (r) { return resolve(r || fakeEffectRes); };
                });
                var asyncPayload = {
                    fetch: function () { return prom; },
                    errorMsg: getMsg,
                    successMsg: getMsg,
                    effectName: effectName,
                    indicator: loading === false ? loading : undefined,
                    channel: '@tkit/model/effect'
                };
                event_1.EventCenter.emit(consts_1.ASYNC_EFFECT_EVENT_NAME, {
                    type: 'doAsyncConfirmed',
                    payload: asyncPayload
                });
            };
        }
        return {
            getRes: function () { return res; },
            getResolver: function () { return rs; },
            getEffect: function () { return interactEffect; }
        };
    };
    /**
     * 局部Model不再使用gerator
     */
    return local
        ? function (action) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, getResolver, getRes, getEffect, res, _b, e_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, put({ type: exports.EFFECTS_START, payload: { effectName: effectName } })];
                    case 1:
                        _c.sent();
                        _a = effectFactory(), getResolver = _a.getResolver, getRes = _a.getRes, getEffect = _a.getEffect;
                        getEffect()();
                        res = getRes();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, , 7]);
                        if (!(typeof effect === 'function')) return [3 /*break*/, 4];
                        _b = res;
                        return [4 /*yield*/, effect(effects, action)];
                    case 3:
                        _b.message = (_c.sent()) || false;
                        _c.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1 = _c.sent();
                        res.code = 10100;
                        res.message = e_1 && e_1['message'] ? e_1['message'] : e_1;
                        return [4 /*yield*/, put({ type: exports.EFFECTS_ERROR, payload: { effectName: effectName } })];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 7: return [4 /*yield*/, put({ type: exports.EFFECTS_END, payload: { effectName: effectName } })];
                    case 8:
                        _c.sent();
                        // 隐藏 loading
                        getResolver()(res);
                        return [2 /*return*/];
                }
            });
        }); }
        : function wrapper(action) {
            var _a, getResolver, getRes, getEffect, res, _b, e_2;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, put({ type: exports.EFFECTS_START, payload: { effectName: effectName } })];
                    case 1:
                        _c.sent();
                        _a = effectFactory(), getResolver = _a.getResolver, getRes = _a.getRes, getEffect = _a.getEffect;
                        getEffect()();
                        res = getRes();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, 7, 11]);
                        if (!(typeof effect === 'function')) return [3 /*break*/, 4];
                        _b = res;
                        return [4 /*yield*/, effect(effects, action)];
                    case 3:
                        _b.message = _c.sent();
                        _c.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        e_2 = _c.sent();
                        res.code = 10100;
                        res.message = e_2 && e_2['message'] ? e_2['message'] : e_2;
                        return [4 /*yield*/, put({ type: exports.EFFECTS_ERROR, payload: { effectName: effectName } })];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 11];
                    case 7: return [4 /*yield*/, exports.cancelled()];
                    case 8:
                        if (!((_c.sent()) || true)) return [3 /*break*/, 10];
                        return [4 /*yield*/, put({ type: exports.EFFECTS_END, payload: { effectName: effectName } })];
                    case 9:
                        _c.sent();
                        // 隐藏 loading
                        getResolver()(res);
                        _c.label = 10;
                    case 10: return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        };
}
exports.effectWrapper = effectWrapper;
// IMP: 移除副作用执行器
// export async function exeGenerator<A extends any[]>(
//   effect: (...args: A) => IterableIterator<any>,
//   ...args: A
// ) {
//   const generator = effect.apply(null, args);
//   let result = generator.next();
//   while (!result.done) {
//     try {
//       const res = await result.value;
//       result = generator.next(res);
//     } catch (e) {
//       return generator.throw(e);
//     }
//   }
//   return generator.value;
// }
//# sourceMappingURL=createModel.js.map